import type { GamePlayerProjectionTrading } from '@library/types/trading';
import type { PlayerDescriptors } from '@library/types/player';
import type { PlayerProjectionsModalProps } from '@bo-components/playerModal/PlayerProjectionsModal';
import { useState } from 'react';

export function usePlayerModal() {
  const [showPlayerModal, setShowPlayerModal] = useState(false);

  const [playerModalProps, setPlayerModalProps] = useState<
    Omit<PlayerProjectionsModalProps, 'leagueInfo' | 'isOpen' | 'onCancelModal'>
  >({
    boardTime: '',
    description: '',
    durationId: '',
    foreignId: '',
    gameId: '',
    gameStartTime: '',
    playerDescriptors: {
      playerDescription: '',
      playerImage: '',
      playerName: '',
      secondaryHeader: ''
    },
    playerId: '',
    position: '',
    startTime: '',
    team: '',
    teamName: ''
  });

  const {
    boardTime,
    description,
    durationId,
    foreignId,
    gameId,
    gameStartTime,
    playerId,
    playerDescriptors,
    position,
    startTime,
    team,
    teamName
  } = playerModalProps;

  const handleSelectPlayerModal = ({
    gameStartDateTime,
    newPlayerDescriptors,
    newProjection
  }: {
    gameStartDateTime: string;
    newPlayerDescriptors: PlayerDescriptors;
    newProjection: GamePlayerProjectionTrading;
  }) => {
    const {
      boardTime: newBoardTime,
      description: newDescription,
      durationId: newDurationId,
      foreignId: newForeignId,
      gameId: newGameId,
      playerId: newPlayerId,
      position: newPosition,
      startTime: newStartTime,
      team: newTeam,
      teamName: newTeamName
    } = newProjection;

    setPlayerModalProps({
      boardTime: newBoardTime,
      description: newDescription,
      durationId: newDurationId ?? '',
      foreignId: newForeignId ?? '',
      gameId: newGameId,
      gameStartTime: gameStartDateTime,
      playerId: newPlayerId ?? '',
      playerDescriptors: newPlayerDescriptors,
      position: newPosition,
      startTime: newStartTime,
      team: newTeam,
      teamName: newTeamName
    });
    setShowPlayerModal(true);
  };

  const onCancelPlayerModal = () => {
    setShowPlayerModal(false);
  };

  return {
    boardTime,
    description,
    durationId,
    foreignId,
    gameId,
    gameStartTime,
    handleSelectPlayerModal,
    onCancelPlayerModal,
    playerId,
    playerDescriptors,
    position,
    showPlayerModal,
    setPlayerModalProps,
    setShowPlayerModal,
    startTime,
    team,
    teamName
  };
}
